import { useReactiveVar } from '@apollo/client';
import { Dialog, DialogContent } from '@mui/material';
import React, { useCallback } from 'react';
import { exchangeRateModalVar } from '../../variables';
import EditComponent from './EditComponent';

const ExchangeRateModalComponent = () => {
  const exchangeRateModal = useReactiveVar(exchangeRateModalVar);

  const close = useCallback((_, reason) => {
    if (reason === 'backdropClick') return true;
    exchangeRateModalVar({ open: false });
  }, []);

  return (
    <Dialog open={exchangeRateModal.open} maxWidth='sm' scroll={'body'} onClose={close} TransitionProps={{ exit: false }}>
      <DialogContent>{exchangeRateModal.open && <EditComponent exchangeRate={exchangeRateModal.item} />}</DialogContent>
    </Dialog>
  );
};

export default ExchangeRateModalComponent;
